import Vue from 'vue';
import Vuex from 'vuex';
import common from '../../static/common.js';
Vue.use(Vuex);
//  应用程序状态    state
//  前端程序数据源，不可直接改变，只能通过已注册的mutations来改变数据，同时也只能通过已注册的getters 获取数据
//  命名规则：驼峰（实体名）
//  --尽量以Object，Array类型为主
let appKey=common.appKey();
const state = {
    jumpUrl:"",
    loginStatus:false,
    fullscreenLoading:false,//加载动画
    watermarkStatus:true,
    //----------------------sessionStorage ---------------------------------
    //sessionStorage 中存放的 user 信息 【login,home,】
    sessionUser:JSON.parse(window.sessionStorage.getItem(appKey))||{}
};

//  应用程序状态变化  mutations
//  前端程序数据源，不可直接改变，只能通过已注册的mutations来改变数据，同时也只能通过已注册的getters 获取数据
//  命名规则：常量命名（大写实体名+下划线_+大写动作名）
//  --每个mutation必须令数据同步变化，禁止在一个mutation中进行异步操作
const mutations = {

};

export default new Vuex.Store({
    state,
    mutations
});



// WEBPACK FOOTER //
// ./src/vuex/store.js